// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { FetchModelResponse, IFetchModel } from '@cian/http-api';
import type { IGetMyOffersForSelectionResponseSchema } from '../../entities/get_my_offers_for_selection/GetMyOffersForSelectionResponseSchema';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export interface IGetMyOffersForSelectionDesktopRequest {
  /** false - если нужны только активные объявления, иначе если нужны все объявления **/
  includeInactive?: boolean;
  /** Вернётся не больше указанного числа объявлений **/
  limit: number;
  /** Начиная с какой позиции по порядку вернуть объявления **/
  offset: number;
  /** Для какого таба объявления **/
  tabType: EQueryParameters;
}

export enum EQueryParameters {
  /** Сдаю **/
  'Rent' = 'rent',
  /** Продаю **/
  'Sale' = 'sale',
}
export type TGetMyOffersForSelectionDesktopResponse =
  | FetchModelResponse<200, 'json', IGetMyOffersForSelectionResponseSchema>
  | FetchModelResponse<400, 'json', IErrorResponseSchema>;

export type TGetMyOffersForSelectionDesktopModel = IFetchModel<
  IGetMyOffersForSelectionDesktopRequest,
  undefined,
  TGetMyOffersForSelectionDesktopResponse
>;

export interface IMappers<TResponse200, TResponse400> {
  200(response: IGetMyOffersForSelectionResponseSchema, headers: Headers): TResponse200;
  400(response: IErrorResponseSchema, headers: Headers): TResponse400;
}
